module.exports = __webpack_public_path__ + "static/dayan-demo-2021-09-1cc5bc636025fa0024a45c29d4c072d9.gif";